

import {model,schema} from  "@mecatran/geo-schemas";
import {serializr, indirectReference, classConstructorParam, indirectObject, funct } from '@mecatran/serializr-extensions';

var { alias, setDefaultModelSchema } = serializr;

class Properties{
    constructor(){
        this.name;
        this.id;
        this.city;
        this.inseecom;
    }
    getName(){ return this.name }
    getCity(){ return this.city }
}

var schemaProperties = {
    factory : schema.factory(Properties),
    props : {
        name : alias('NOM_POI',true),
        city : alias('COMMUNE',true),
        inseecom : true,
        id : alias('OBJECTID',true)
    }
}

// model.Properties = Properties;


setDefaultModelSchema( model.Geojson, schema.schemaGeojson );
setDefaultModelSchema( model.Feature, schema.schemaFeature );
setDefaultModelSchema( model.Geometry, schema.schemaGeometry );
setDefaultModelSchema( model.Properties, schema.schemaProperties );

export {model};



